<template>
    <button type='button'>{{text}}</button>
</template>

<script>
export default {
    props:['text']

}
</script>
<style lang="scss" scoped>
  button{
     width: 4rem;
     height: 1.875rem;
     background-color: #ffffff;
     box-shadow: 0px 2px 4px 0px 
        rgba(0, 0, 0, 0.1);
     border-radius: 4px;
     border: solid 0px rgba(151, 151, 151, 0.2);
     font-size: 0.7rem;
     cursor: pointer;
     &:focus{
       outline: 0;
     }
  }
</style>